export const flatArray = <T>(
    results: Array<T[]>
): T[] => {
    return results.reduce<T[]>((memo, cards) => {
        memo.push(...cards);
        return memo;
    }, []);
}
